import Head from 'next/head';
import React from 'react';
import { SWRConfig } from 'swr';
import { Toast } from 'antd-mobile';
import SWCError from '~/common/http/SWRError';
import { statusWillRetry } from '~/common/http/Status';
import styles from './App.module.css';

interface IAppProps {
  children: React.ReactNode;
}

export default function App(props: IAppProps) {
  const { children } = props;

  return (
    <SWRConfig
      value={{
        onLoadingSlow: () => {
          Toast.show({
            content: '当前网络有点慢，请耐心等待',
            position: 'bottom',
          });
        },
        onErrorRetry: (error: SWCError, key, config, revalidate, { retryCount }) => {
          if (!error.message.includes('aborted a request') && !statusWillRetry.includes(error.status)) {
            // 如果不需要重试，直接toast提示
            Toast.show({ content: `${error.message}[${error.status}]`, position: 'bottom' });
            return;
          }
          let timeoutError;
          if (error.message.includes('aborted a request')) {
            // 如果是命中了超时逻辑而被结束，需要手动触发重试
            timeoutError = new SWCError('网络超时啦，请稍后再试', 1000, config, undefined);
          }
          // Only retry up to 10 times.
          if (retryCount >= 3) {
            // 如果重试都失败，则toast提示
            const finalError = timeoutError || error;
            Toast.show({ content: `${finalError.message}[${finalError.status}]`, position: 'bottom' });
            return;
          }
          // Retry after 2 seconds.
          setTimeout(() => revalidate({ retryCount }), 2000);
        },
      }}
    >
      <Head>
        <title>红松小课</title>
        <link
          rel='icon'
          type='image/x-icon'
          href='https://fjkt-static.hongsong.info/image/1710903522886_hsxk_logo.png'
        />
      </Head>
      <div className={styles.container}>{children}</div>
    </SWRConfig>
  );
}
